import { type Html, html, View } from 'rune-ts';
import klass from './FormRow.module.scss';
import { htmlIf } from '../../../util';
import { FormRowAsteriskIcon } from '../Icon';
import { font } from '../../../typography';

export interface FormRowData {
  label: string | Html;
  content: string | Html | View | View[];
  field_right?: string | Html;
  description?: string | Html;
  required?: boolean;
  custom_klass?: string;
  size?: 'medium' | 'small';
}

/**
 * 해당 컴포넌트는 디자인 시스템이 따로 존재하지 않는 편의상 만든 컴포넌트 입니다.
 * 디자인 수정 사항 발생시 sizeOptions 에 추가하여 스타일 분기를 해주시길 바랍니다.
 */
export class FormRow extends View<FormRowData> {
  static readonly sizeOptions = {
    medium: {
      field_name_font: font('16_bold'),
      content_font: font('16_medium', '14_medium'),
      size_class: klass.medium,
    },
    small: {
      field_name_font: font('14_bold'),
      content_font: font('12_medium'),
      size_class: klass.small,
    },
  } as const;

  override template() {
    const {
      label,
      content,
      description,
      required = false,
      custom_klass = '',
      field_right = html``,
    } = this.data;

    const { field_name_font, content_font, size_class } = FormRow.sizeOptions[this.size];

    return html`
      <div class="${klass.form_row} ${size_class} ${custom_klass}">
        <div class="${klass.field} ">
          <span class="${klass.field_name} ${field_name_font}">
            ${label} ${required ? FormRowAsteriskIcon : ''}
          </span>
          <span class="${klass.field_right} ${font('12_medium')}">${field_right}</span>
        </div>
        <div class="${klass.content} ${content_font}">${content}</div>
        ${htmlIf(
          html`<div class="${klass.description} ${font('12_medium')}">${description}</div>`,
          !!description,
        )}
      </div>
    `;
  }

  setPropsAndRedraw(props: Partial<FormRowData>) {
    Object.assign(this.data, props);
    this.redraw();
  }

  get size() {
    return this.data.size || 'medium';
  }
}
